import styled from 'styled-components';

interface IRadioInput {
  selected?: boolean;
}

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const RadioInput = styled.label<IRadioInput>`
  display: flex;
  align-items: center;
  margin: 5px 20px 5px 0;
  cursor: pointer;

  span {
    color: #8c8c8c;
    font-size: 16px;
    font-weight: 500;
  }

  > div {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 8px;
    transition-duration: 0.3s;
    background: #fff;
    border: ${(props) =>
      props.selected ? '8px solid #ff6900' : '1px solid #e1e1e1'};
  }

  input {
    display: none;
  }
`;
